<template>
	<b-card>
		<div slot="header" class="d-flex justify-content-between custom-card-header">
			<span class="card-header-title"> {{ $t('sidebar.warehouse-management.requests') }}</span>
			<div class="card-header-actions">
				<div class="searchInCard">
					<b-input-group size="sm">
						<b-form-input v-model="payload.keyword" size="sm" :placeholder="$t('contragent.filter')"
									  autocomplete="off" @input="getList"/>
						<b-input-group-append>
							<b-button :disabled="!payload.keyword" @click="getList(payload.keyword = '')">
								{{ $t('contragent.clear') }}
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</div>
			</div>
		</div>
		<table class="table table-hover table-bordered table-striped mt-3">
			<thead>
			<tr>
				<th class="text-center">№</th>
				<th class="text-center">{{ $t('incomes.name') }}</th>
				<th class="text-center">{{ $t('incomes.fromDepartment') }}</th>
				<th class="text-center">{{ $t('incomes.toDepartment') }}</th>
				<th class="text-center">{{ $t('pricing.date') }}</th>
				<th class="text-center">{{ $t('contragent.category-name') }}</th>
				<th class="text-center">{{ $t('sale.status') }}</th>
				<th class="text-center" style="width: 8%">{{ $t('actions.title') }}</th>
			</tr>
			</thead>
			<tbody>
			<template v-if="items.items.length">
			<tr v-for="(item, index) in items.items" :key="`item-${index}`">
				<td class="text-center">{{ paginate(index, payload.page, payload.limit) }}</td>
				<td class="text-center">{{ item.regNumber }}</td>
				<td class="text-center">{{ item.fromDepartmentName }}</td>
				<td class="text-center">
					<span v-for="name in item.toDepartmentNames" class="mr-1">
						{{ name }}
					</span>
				</td>
				<td class="text-center">{{ item.regDate }}</td>
				<td class="text-center">
					{{ item.subCategoryName }} /
					{{ item.sub2CategoryName }} /
					{{ item.sub3CategoryName }}
				</td>
				<td class="text-center">{{ item.status }}</td>
				<td class="text-center">
					<i @click="editDoc(item.id)" style="cursor: pointer" class="fa fa-edit text-primary"></i>
				</td>
			</tr>
			</template>
			<tr v-else>
				<td colspan="6" class="text-center">
					<h5><b>Информация не найдена !</b></h5>
				</td>
			</tr>
			</tbody>
		</table>
		<nav>
			<b-pagination
				:total-rows="items.total"
				:per-page="payload.limit"
				v-model="payload.page"
				aria-controls="table"/>
		</nav>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import UsersService from "../../../services/users.sevice";
import ReferencesService from "../../../services/references.sevice";
import WhDocument from "../../../services/wh-document.service";

export default {
	name: "index",
	components: {Multiselect},
	data() {
		return {
			selectedDepIds: [],
			departmentId: null,
			toDepartmentId: [],
			fromDepartments: '',
			toDepartments: '',
			subCategory_s: [],
			subCategoryId: null,
			subCategory1_s: [],
			subCategory1Id: null,
			subCategory2_s: [],
			subCategory2Id: null,
			items: {},
			payload: {
				page: 1,
				limit: 20,
				keyword: '',
			},
			data: {
				subCategoryId: null,
				sub2CategoryId: null,
				sub3CategoryId: null,
				fromDepartmentId: null,
				toDepartmentIds: []
			}
		}
	},
	methods: {
		selectedDep(selectedOption) {
			this.data.fromDepartmentId = selectedOption.id
		},
		async selectedSubGroup($event) {
			this.data.subCategoryId = $event.id
			await ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory1_s = res.data
			})
		},
		async selectedSubCategory($event) {
			this.data.sub2CategoryId = $event.id
			await ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory2_s = res.data
			})
		},
		subcategory($event) {
			this.data.sub3CategoryId = $event.id
		},
		createRequest() {
			this.spinner = true
			if (this.data.fromDepartmentId != null && this.data.toDepartmentIds.length > 0) {
				WhDocument.createRequestDoc(this.data).then(res => {
					this.$router.push(`/request-warehouse/create_or_edit/${res.data.id}`)
					this.$vs.notify({
						title: 'Success',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					})
				}).catch(e => {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: e,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			} else {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: this.$t('words.validation-error'),
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
			this.spinner = false
		},
		deleteDoc(id) {
			this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
				hideHeader: true,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: this.$t('actions.yes'),
				cancelTitle: this.$t('actions.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					WhDocument.deleteRequestDoc(id).then(res => {
						this.getList();
						this.$vs.notify({
							title: 'Success',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					}).catch(e => {
						this.$vs.notify({
							title: this.$t('words.error'),
							text: e,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
				}
			})
		},
		editDoc(id) {
			this.$router.push(`/request-warehouse/create_or_edit_counter/${id}`)
		},
		async getList() {
			await WhDocument.getRequestDocsForCounter(this.payload).then(res => {
				this.items = res.data
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		}
	},
	watch: {
		toDepartmentId: {
			handler(v) {
				this.data.toDepartmentIds = v.map(e => e.id)
			}
		},
		departmentId: {
			handler(v) {
				this.data.fromDepartmentId = v.map(e => e.id)
			}
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(res => {
			this.fromDepartments = res.data.permittedDepartments
			this.toDepartments = res.data.transferPermittedDepartments
		})
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.subCategory_s = res.data
		})
		this.getList();
	}
}
</script>

<style scoped>

</style>
